import WelcomeCallTable from './WelcomeCallTable'

export default WelcomeCallTable
